<template>
  <div>
    <div id="topbar">
      <div class="topbar-left">
        <div class="logo"><img src="/img/TurkishRestaurantLogo.png"/></div>
        <div v-if="showRoleSelect" class="manage">
          <span>Manage:</span>

          <select class="rest-select ml-2"  v-model="restaurantId" @change="onRestaurantChange">

            <option value="-1" v-if="activeUserInfo.user_group > 3">Master Admin</option>
            <option value="-1" v-else-if="activeUserInfo.user_group > 2">Editor</option>
            <option value="-1" v-else>Master Admin</option>
            <option v-for="option in user_group_options"
                    :key="option.value"
                    :value="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>
      <div class="topbar-right">
        <div class="user" @click="showUser = true"><i class="fas fa-user-cog"></i> {{ activeUserInfo.name }} {{ activeUserInfo.last_name }}</div>
        <div id="user-menu" class="user-menu-cont" :class="(showUser) ? 'active' : ''">
          <div class="close-menu" @click="showUser = false">Close <i class="fas fa-times-circle"></i></div>
          <ul class="user-menu">
            <a href="/account">
              <li class="user-menu-item"><i class="fas fa-cog"></i> Account Settings</li>
            </a>
            <a href="/logout">
              <li class="user-menu-item"><i class="fas fa-sign-out-alt"></i> Log Out</li>
            </a>
            <a href="/help">
              <li class="user-menu-item"><i class="fas fa-question-circle"></i> Help</li>
            </a>
          </ul>
        </div>
      </div>
    </div>

    <div id="topbar-mobile">
      <div class="topbar-left">
        <div class="mobile-menu-trigger" @click="toggleSidebar"><i class="fas fa-bars"></i></div>
      </div>
      <div class="topbar-mid">
        <div class="logo"><img src="/img/TurkishRestaurantLogo.png"/></div>
      </div>
      <div class="topbar-right">
        <div class="user" @click="showUser = true"><i class="fas fa-user-cog"></i> </div>
        <div id="user-menu" class="user-menu-cont" :class="(showUser) ? 'active' : ''">
          <div class="close-menu" @click="showUser = false">Close <i class="fas fa-times-circle"></i></div>


          <div v-if="showRoleSelect" class="manage">
          <span>Manage:</span>
          <select class="rest-select"  v-model="restaurantId" @change="onRestaurantChange">

            <option value="-1" v-if="activeUserInfo.user_group > 3">Master Admin</option>
            <option value="-1" v-else-if="activeUserInfo.user_group > 2">Editor</option>
            <option value="-1" v-else>Master Admin</option>
            <option v-for="option in user_group_options"
                    :key="option.value"
                    :value="option.value">{{ option.label }}</option>
          </select>
        </div>
          <ul class="user-menu">
            <a href="/account">
              <li class="user-menu-item"><i class="fas fa-cog"></i> Account Settings</li>
            </a>
            <a href="/logout">
              <li class="user-menu-item"><i class="fas fa-sign-out-alt"></i> Log Out</li>
            </a>
            <a href="/help">
              <li class="user-menu-item"><i class="fas fa-question-circle"></i> Help</li>
            </a>
          </ul>
          <div class="user-name">User: {{ activeUserInfo.name }} {{ activeUserInfo.last_name }}</div>
        </div>
      </div>
    </div>

    <div id="sidebar" :class="{ active: sidebarActive }">
      <ul class="side-menu">
        <li v-if="activeUserInfo.user_group > 3" class="side-menu-item now-managing">
          <h3  class="nm-heading">Now Managing</h3>
          <h2 class="nm-title">{{ selectedRestaurant ? selectedRestaurant.user_property['Restaurant-Name'] : 'Master Admin' }}</h2>

        </li>
        <li v-else-if="activeUserInfo.user_group >= 2" class="side-menu-item now-managing">
          <h3  class="nm-heading">Managing</h3>
          <h2 class="nm-title">{{ selectedRestaurant ? selectedRestaurant.user_property['Restaurant-Name'] : 'Editor' }}</h2>

        </li>

        <a href="/">
          <li class="side-menu-item" :class="{ active: activePage === 'dashboard' || activePage === 'home' }">
            <i class="fas fa-desktop"></i> Dashboard</li>
        </a>
        <a href="/orders">
          <li class="side-menu-item" :class="{ active: activePage === 'orders' }"><i class="fas fa-shopping-basket"></i> Orders</li>
        </a>
        <a href="/menu">
          <li class="side-menu-item" :class="{ active: activePage === 'menu' }"><i class="fas fa-utensils"></i> Menu</li>
        </a>
        <a href="/catering-menu" v-if="canSee('catering-menu')">
          <li class="side-menu-item" :class="{ active: activePage === 'catering-menu' }"><i class="fas fa-utensils"></i>Catering Menu</li>
        </a>
        <a href="/catering-orders" v-if="canSee('catering-orders')">
          <li class="side-menu-item" :class="{ active: activePage === 'catering-orders' }"><i class="fas fa-utensils"></i>Catering Orders</li>
        </a>
        <a href="/reservations" v-if="canSee('reservations')">
          <li class="side-menu-item" :class="{ active: activePage === 'reservations' }"><i class="fas fa-calendar"></i> Reservations</li>
        </a>
        <a href="/hours" v-if="canSee('hours')">
          <li class="side-menu-item" :class="{ active: activePage === 'hours' }"><i class="far fa-clock"></i> Working Hours</li>
        </a>
        <a href="/delivery-zones" v-if="canSee('delivery-zones')">
          <li class="side-menu-item"  :class="{ active: activePage === 'delivery-zones' }"><i class="fas fa-route"></i> Delivery Zones</li>
        </a>
        <a href="/specials" v-if="canSee('specials')">
          <li class="side-menu-item"  :class="{ active: activePage === 'specials' }"><i class="fas fa-star"></i> Special Deals</li>
        </a>
        <a href="/events" v-if="canSee('events')">
          <li class="side-menu-item"  :class="{ active: activePage === 'events' }"><i class="fas fa-calendar"></i> Events</li>
        </a>
        <a href="/coupon-settings" v-if="canSee('coupon-settings')">
          <li class="side-menu-item"  :class="{ active: activePage === 'coupon-settings' }"><i class="fas fa-ticket-alt"></i> Coupon Settings</li>
        </a>
        <a href="/contents" v-if="canSee('contents')">
          <li class="side-menu-item"  :class="{ active: activePage === 'contents' }"><i class="fas fa-bullhorn"></i> Marketing</li>
        </a>

        <a href="/onboarding-forms" v-if="canSee('onboarding-forms')">
          <li class="side-menu-item" :class="{ active: activePage === 'onboarding-forms' }"><i class="fas fa-utensils"></i>Onboarding Forms</li>
        </a>
        <a href="/users" v-if="canSee('users')">
          <li class="side-menu-item"  :class="{ active: activePage === 'users' }"><i class="fas fa-users-cog"></i> Users</li>
        </a>
        <a href="/financials" v-if="canSee('financials')">
          <li class="side-menu-item" :class="{ active: activePage === 'financials' }"><i class="fas fa-file-invoice-dollar"></i> Financials</li>
        </a>
<!--        <a href="/seo-settings" v-if="canSee('seo-settings')">
          <li class="side-menu-item" :class="{ active: activePage === 'seo-settings' }"><i class="fas fa-cog"></i>Seo Settings</li>
        </a>-->
        <a v-if="canSee('property-management')" href="/property-management">
          <li class="side-menu-item"  :class="{ active: activePage === 'property-management' }"><i class="fas fa-wrench"></i>System Properties</li>
        </a>
        <a v-if="canSee('live-cities')" href="/live-cities">
          <li class="side-menu-item"  :class="{ active: activePage === 'live-cities' }"><i class="fas fa-wrench"></i>Live Cities</li>
        </a>
        <a href="/catering-settings"  v-if="canSee('catering-settings')">
          <li class="side-menu-item" :class="{ active: activePage === 'catering-settings' }"><i class="fas fa-car-side"></i> Catering Settings</li>
        </a>
        <a href="/restaurant-settings"  v-if="canSee('restaurant-settings')">
          <li class="side-menu-item" :class="{ active: activePage === 'restaurant-settings' }"><i class="fas fa-cog"></i> Restaurant Settings</li>
        </a>
        <a href="/gifts"  v-if="canSee('gifts')">
          <li class="side-menu-item" :class="{ active: activePage === 'gifts' }"><i class="fas fa-cog"></i> Gift Cards</li>
        </a>
        <a href="/restaurant-sales"  v-if="canSee('restaurant-sales')">
          <li class="side-menu-item" :class="{ active: activePage === 'restaurant-sales' }"><i class="fas fa-star"></i> Restaurant Sales</li>
        </a>
      </ul>
      <div id="copyright">©
        {{ new Date().getFullYear() }}
        | Turkish Restaurant
      </div>
    </div>

    <div id="mainarea">
            <transition :name="routerTransition" mode="out-in">
              <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
            </transition>
    </div>

  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import vSelect from 'vue-select'

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    vSelect
  },
  data () {
    return {
      showUser          : false,
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      activePage: this.$router.currentRoute.name,
      user_group_options: [],
      restaurantId      : -1,
      sidebarActive: false
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    },
    '$store.state.api.selectedRestaurant' () {
      if (this.activeUserInfo.user_group === 4) {
        this.getUserList(2)
        this.restaurantId = this.selectedRestaurant.id
      }
    }
  },
  computed: {
    showRoleSelect () {
      return this.activeUserInfo.user_group > 2 || (this.activeUserInfo.user_group === 3 && JSON.parse(this.activeUserInfo.user_property['restaurants']).length > 1)
    },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist || JSON.parse(localStorage.getItem('restaurantlist'))
    },
    activeUserInfo () {
      return this.$store.state.api.currentUser
    }
  },
  methods: {
    toggleSidebar () {
      this.sidebarActive = !this.sidebarActive
    },
    canSee (url) {
      const route_page = this.$router.options.routes[0].children.filter(route => route.name === url)[0]
      return route_page.meta.minLevelRequired.includes(this.activeUserInfo.user_group) || this.activeUserInfo.user_group === 4
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    getUserList (group_id) {
      const payload = {
        user_group: group_id
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUserList', payload)
        .then(() => {
          this.$vs.loading.close()
          this.getRestaurantList()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    onRestaurantChange () {
      let selectedRestaurant = this.restaurantlist.filter((restaurant) => {
        return restaurant.id === this.restaurantId
      })

      if (this.restaurantId === -1) {
        selectedRestaurant = null
      }
      this.$store.commit('api/SET_SELECTED_RESTAURANT', selectedRestaurant[0])

      location.reload()
    },
    getRestaurantList () {
      const self = this
      const list = this.restaurantlist
      const opt_list = []
      list.forEach(function (key) {
        if (self.activeUserInfo.user_group === 3) {
          const managing_restaurants = JSON.parse(self.activeUserInfo.user_property['restaurants'])
          if (managing_restaurants.includes(key.id)) {
            opt_list.push({label: key.user_property['Restaurant-Name'], value: key.id})
            self.restaurantId = key.id
          }
        } else {
          opt_list.push({label: key.user_property['Restaurant-Name'], value: key.id})
        }
      })

      this.user_group_options = opt_list

    }
  },
  mounted () {
    this.getUserList(2)
    if (this.selectedRestaurant) {
      this.restaurantId = this.selectedRestaurant.id
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

  }
}

</script>

